import {HostListener, Injectable} from "@angular/core";

@Injectable()
export class BackProcessorService{
  static state:any = undefined;
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed', event.state);
    BackProcessorService.state = event.state;
  }
  addListener(){
    /*window.addEventListener("popstate",(event)=>{
      console.log("popstate", event.state);
      this.state = event.state;
    });*/
  }
  getState(){
    return BackProcessorService.state;
  }
  addState(state:any,title:string){
    history.pushState(state,title);
  }

  setState(state: any) {
    BackProcessorService.state = state;
  }
}
